module.exports = __webpack_public_path__ + "img/15.d8f51c3c.jpg";